import React, { useState } from 'react';
import OrderForm from './OrderForm';
import { useAppContext } from './AppContext';

const Contact = () => {
  const { loggedIn } = useAppContext();
  const [showForm, setShowForm] = useState(false);
  
  const services = {
    id: 1,
    title: '/ Your Feedback',
    description: 'Custom website development tailored to your needs. Responsive and modern design with the latest technologies.',
  };

  const handleOpenForm = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <div className="relative p-6 min-h-screen flex flex-col bg-gradient-to-r from-purple-600 via-sky-600 to-blue-900 dark:from-gray-600 dark:via-gray-900 dark:to-black text-white overflow-hidden duration-500">
      <div className="absolute pointer-events-none top-0 left-0 w-full h-full overflow-hidden z-10">
        <div className="diamond"></div>
        <div className="diamond diamond-2"></div>
        <div className="diamond diamond-3"></div>
        <div className="diamond diamond-4"></div>
        <div className="diamond diamond-5"></div>
        <div className="diamond diamond-6"></div>
      </div>

      <h1 className="text-3xl w-full pb-4 neon-text border-b-2 sm:text-4xl text-center font-bold mb-3 z-20">Contact Us</h1>

      {!loggedIn ? (
        <div className="text-center  ">
          <p className="text-2xl mb-2">Please log in or create an account to contact us.</p>
          <div className='w-full flex justify-center'>
          <a href="/" className="bg-green-500 dark:bg-green-950 text-center max-w-64  hover:bg-green-700 mb-6 text-white font-bold py-2 px-4 rounded">Login / Singup</a>
          </div>
        
          <img src="/communication.jpg" alt="Contact Us" className="mx-auto skeleton mb-4 rounded-lg shadow-lg"/>
           </div>
      ) : (
        <div className="text-center mt-1">
          <p className="text-2xl mb-4">We'd love to hear from you! Click below to send us a message.</p>
          <button
            onClick={handleOpenForm}
            className="bg-teal-500 mb-6 hover:bg-teal-700 text-white font-bold py-2 px-4 rounded"
          >
            Send Us a Message
          </button>
          <img src="/communication.jpg" alt="Contact Us" className="mx-auto skeleton mb-4 rounded-lg shadow-lg"/>
      
          {showForm && (
            <OrderForm
              service={services}
              onClose={handleCloseForm}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Contact;
